import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ICommandBase } from "@Quest/cqrs";
import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue';
import { SaveReviewGridCommandV1 } from '@Quest/PortfolioScenarios/Domain/commands-core';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { ReviewPageReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import Vue from "vue";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, PortfolioScenarioNavigation, ProjectsGrid
    }
})
export default class ReviewPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }
    get portfolioId(): string { return this.rm?.PortfolioId ?? ''; }


    rm: ReviewPageReadModel | null = null;

    grid: ProjectsGridViewModel = new ProjectsGridViewModel();

    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveReviewGridCommand()
    {
        const grid = this.grid.getJson();
        this.invokeSaveReviewGridCommandV1(this.workspaceId, this.portfolioId, this.scenarioId, grid)
    }

    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }


    mounted()
    {
        document.title = "Portfolio Plan - Review";
        this.runReviewPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ReviewPageReadModel")
        {
            this.rm = model as ReviewPageReadModel;

            Vue.nextTick(() =>
            {
                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options);
                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveReviewGridCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
    }
}